import BaseFormPresenter from "../../base/BaseFormPresenter";

class CollectionFormPresenter extends BaseFormPresenter {
  componentDidMount() {
    this.init();
    this.getObject();
  }

  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async getObject() {
    const collection = this.view.getCollectionName();
    console.log("collection", collection);
    console.log("first");
    const id = this.object.id || this.view.getObjectId();
    if (id) {
      // const params = { include: ["all"] };
      const params = {
        include: [
          // "all",
          "committeeRelation",
          "committeeRelation.Designation",
          "committeeRelation.employee",
          "requestType",
          "employee",
          "supervisor",
          "groupEmployee",
        ],
      };
      try {
        this.view.showProgress();
        this.object = await this.getObjectUseCase.execute(collection, id, {
          params,
        });
        this.view.hideProgress();
        // console.log("objecrt", this.object);
        this.view.setObject(this.object);
      } catch (error) {
        this.view.hideProgress();
        this.view.showError(error);
      }
    }
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      if (this.view.getObjectId()) {
        this.view.navigateBack();
      }
      return;
    }

    try {
      this.view.submitting();
      await this.save();
      this.view.submissionSuccess();
      this.view.showSuccessSnackbar("Successfully saved!");
      if (this.view.getObjectId()) {
        this.view.navigateBack();
      }
    } catch (error) {
      this.view.showError(error);
    }
  }
}

export default CollectionFormPresenter;
